import { useEffect, useState } from 'react';

import { getMixpanelAnalyticsTags } from '@jane/bloom/services/tracking/mixpanel';

/**
 * Hook to retrieve Mixpanel analytics tags (UTM parameters) in a hydration-safe manner.
 *
 * Returns null during SSR and initial render, then fetches tags after hydration
 * to avoid SSR/client mismatch warnings.
 * @returns {string | null} Analytics tags as a query string (e.g., "utm_source=google&utm_medium=cpc") or null
 */
export function useMixpanelAnalyticsTags(): string | null {
  // Start with null to match server render, then populate after hydration
  const [analyticsTags, setAnalyticsTags] = useState<string | null>(null);

  useEffect(() => {
    // Fetch analytics tags after hydration to avoid SSR mismatch
    setAnalyticsTags(getMixpanelAnalyticsTags());
  }, []);

  return analyticsTags;
}
